const BannerPse = () => {
    return (
        <div className="card-transaction-info"
        style={{ width: "75%", margin: "auto", padding: "20px 20px"  }}>
            <span>
                1. Todas las compras y pagos por PSE son realizadas en linea y la confirmacion es inmediata.
            </span>
            <br/>
            <span>
                2. Algunos bancos tienen un procedimiento de autenticación en su página (por ejemplo, una segunda clave),
                si nunca has realizado pagos por internet con tu cuenta de ahorros o corriente es posible que necesites
                tramitar una autorizacion ante tu banco.
            </span>
        </div>
    )
}

export default BannerPse;